import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import { Tooltip } from '@design-system/tooltip';
import { Typography } from '@design-system/typography';
import { isBrowser } from '@phx-husky/browser-helpers';
import { useScreenRecognition } from '@phx-husky/use-screen-recognition';
import classNames from 'classnames';
import { forwardRef, useState, useEffect } from 'react';
import { Button } from '@design-system/button';
import { Link } from '@design-system/link';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var ShareButton = function ShareButton(_ref) {
  var label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    shareContent = _ref.shareContent;
  return jsx(Button, Object.assign({
    className: "cds-share-block__share-button",
    onClick: function onClick() {
      return shareContent();
    },
    variant: "primary",
    "aria-label": ariaLabel,
    iconPrefix: {
      props: {
        icon: 'share'
      }
    }
  }, {
    children: label
  }));
};
var ShareList = function ShareList(_ref2) {
  var shareLinks = _ref2.shareLinks,
    label = _ref2.label,
    ariaLabel = _ref2.ariaLabel,
    shareContent = _ref2.shareContent,
    location = _ref2.location;
  return (shareLinks === null || shareLinks === void 0 ? void 0 : shareLinks.length) ? jsx("ul", Object.assign({
    "aria-labelledby": "share-block",
    className: "cds-share-block__items"
  }, {
    children: shareLinks.map(function (_a) {
      var href = _a.href,
        _a$size = _a.size,
        size = _a$size === void 0 ? 'large' : _a$size,
        _a$variant = _a.variant,
        variant = _a$variant === void 0 ? 'subtle-icon' : _a$variant,
        linkItem = __rest(_a, ["href", "size", "variant"]);
      return jsx("li", Object.assign({
        className: "cds-share-block__item"
      }, {
        children: jsx(Link, Object.assign({
          className: "cds-share-block__share-link",
          size: size,
          variant: variant,
          href: "".concat(href).concat(location)
        }, linkItem))
      }), href);
    })
  })) : jsx(ShareButton, {
    ariaLabel: ariaLabel,
    shareContent: shareContent,
    label: label
  });
};
var ShareBlock = forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    shareLinks = _ref3.shareLinks,
    label = _ref3.label,
    _ref3$titleOptions = _ref3.titleOptions,
    titleOptions = _ref3$titleOptions === void 0 ? {
      variant: 'body',
      tag: 'p',
      size: 's'
    } : _ref3$titleOptions,
    showCopyButton = _ref3.showCopyButton,
    copyButtonAriaLabel = _ref3.copyButtonAriaLabel,
    shareButtonAriaLabel = _ref3.shareButtonAriaLabel,
    copyButtonDefaultLabel = _ref3.copyButtonDefaultLabel,
    copyButtonActiveLabel = _ref3.copyButtonActiveLabel,
    _ref3$align = _ref3.align,
    align = _ref3$align === void 0 ? 'start' : _ref3$align;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useState3 = useState(copyButtonDefaultLabel),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipContent = _useState4[0],
    setTooltipContent = _useState4[1];
  var _useScreenRecognition = useScreenRecognition(),
    isMobile = _useScreenRecognition.isMobile;
  useEffect(function () {
    return setLocation(isBrowser() ? window.location.href : '');
  }, []);
  var handleClickCopy = function handleClickCopy(text) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setTooltipContent(copyButtonActiveLabel);
              _context.next = 4;
              return (_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(text);
            case 4:
              return _context.abrupt("return", _context.sent);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error("Error while copy to clipboard", _context.t0);
              return _context.abrupt("return", null);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
  var shareContent = function shareContent() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return navigator === null || navigator === void 0 ? void 0 : navigator.share({
                url: location
              });
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.error("Error while sharing content", _context2.t0);
              return _context2.abrupt("return", null);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
  };
  return jsx("div", Object.assign({
    ref: ref,
    className: classNames('cds-share-block', className, "cds-share-block--align-".concat(align)),
    "data-testid": "cds-share-block"
  }, {
    children: !isMobile ? jsxs(Fragment, {
      children: [(shareLinks === null || shareLinks === void 0 ? void 0 : shareLinks.length) ? jsxs("div", Object.assign({
        className: "cds-share-block__header"
      }, {
        children: [jsx(Icon, {
          icon: "share"
        }), label && jsx(Typography, Object.assign({
          className: "cds-share-block__title"
        }, Object.assign(Object.assign({}, titleOptions), {
          content: "".concat(label, ":")
        })))]
      })) : null, jsx(ShareList, {
        shareLinks: shareLinks,
        label: label,
        ariaLabel: shareButtonAriaLabel,
        location: location,
        shareContent: shareContent
      }), showCopyButton ? jsx(Tooltip, {
        className: "cds-share-block__tooltip",
        label: copyButtonAriaLabel,
        portalQuerySelector: ".cds-tooltip",
        isTooltipContentInteractive: true,
        icon: "copy",
        onClickTooltip: function onClickTooltip() {
          return handleClickCopy(location);
        },
        onBlurTooltip: function onBlurTooltip() {
          return setTooltipContent(copyButtonDefaultLabel);
        },
        content: jsx("span", {
          children: tooltipContent
        })
      }) : null]
    }) : jsx(ShareButton, {
      ariaLabel: shareButtonAriaLabel,
      shareContent: shareContent,
      label: label
    })
  }));
});
export { ShareBlock };